module.exports = __webpack_public_path__ + "img/popup.e75aa127.png";